import React, { useState, useContext, useCallback } from "react";
import { sortingOptions, sortingDirectionMap } from "shared/constants/constants";

const SortingContext = React.createContext();

export function useSortingContext() {
  return useContext(SortingContext);
}

const initialValue = {
  name: sortingOptions[0].name,
  key: sortingOptions[0].value,
  direction: sortingDirectionMap.get("DESCEND"),
};

function readStoredSorting(storageKey) {
  if (!storageKey) return null;
  try {
    return JSON.parse(sessionStorage.getItem(storageKey));
  } catch (error) {
    return null;
  }
}

export function SortingProvider({ children, storageKey }) {
  const [storedSorting] = useState(() => readStoredSorting(storageKey));
  const [applySorting, setApplySorting] = useState(() => storedSorting || {});
  const [pendingSort, setPendingSort] = useState(() => storedSorting || initialValue);

  const applySortingHandler = useCallback(() => {
    setApplySorting(pendingSort);
    if (storageKey) sessionStorage.setItem(storageKey, JSON.stringify(pendingSort));
  }, [pendingSort, storageKey]);

  const clearSorting = () => {
    setApplySorting({});
    setPendingSort(initialValue);
    if (storageKey) sessionStorage.removeItem(storageKey);
  };

  return (
    <SortingContext.Provider
      value={{
        pendingSort,
        setPendingSort,
        applySortingHandler,
        applySorting,
        clearSorting,
      }}
    >
      {children}
    </SortingContext.Provider>
  );
}
